import {fonts} from '../../../theme/foundations/fonts'
import sizes from '../../../theme/foundations/sizes'
import {pxToRem} from '../../../utills/pxToRem'

const {md} = sizes.container

export const SiteMapStyle = {
    padding: `${pxToRem(24)} 0`,
    fontFamily: fonts.primary,
    h1: {
        ...commonHeadingStyles(pxToRem(40), pxToRem(10.4)),
        textAlign: 'center',
        paddingBottom: pxToRem(20),
        marginBottom: pxToRem(14),
        [`@media (max-width: ${md})`]: {
            fontSize: pxToRem(28),
            letterSpacing: pxToRem(7.28),
            margin: `${pxToRem(10)} 0`
        }
    },
    h2: {
        ...commonHeadingStyles(pxToRem(28), pxToRem(2.8)),
        margin: `${pxToRem(24)} 0`,
        paddingTop: pxToRem(10),
        [`@media (max-width: ${md})`]: {
            fontSize: pxToRem(20),
            margin: `${pxToRem(16)} 0`
        }
    },
    '.category-list': {
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        color: 'black'
    },
    a: {
        color: 'black'
    },
    'a:hover': {
        color: 'cav_hover_brightred',
        textDecoration: 'none',
        outline: 0
    },
    '.category-item': {
        flex: '1 1 50%',
        boxSizing: 'border-box',
        [`@media (max-width: ${md})`]: {
            paddingLeft: pxToRem(21),
            flex: '1 100%'
        }
    },
    ul: {
        margin: `${pxToRem(14)} 0`,
        paddingLeft: pxToRem(40)
    },
    'ul li a': {
        fontSize: pxToRem(14),
        fontWeight: 400
    }
}

// Helper function for common heading styles
function commonHeadingStyles(fontSize, letterSpacing) {
    return {
        fontSize,
        fontWeight: 700,
        letterSpacing,
        textTransform: 'uppercase',
        color: 'black'
    }
}
